import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { MedicalSpecialtyPickerComponent } from '@modules/shared/medical-specialty-picker/medical-specialty-picker.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TuiSwitch } from '@taiga-ui/kit';
import { first } from 'rxjs';
import { DepartmentAdminService } from '../department-admin/department-admin.service';
import { TuiAnimated } from '@taiga-ui/cdk';

@UntilDestroy()
@Component({
  hostDirectives: [TuiAnimated],
  selector: 'pxc-department-settings-admin',
  imports: [FormsModule, ReactiveFormsModule, MedicalSpecialtyPickerComponent, TuiSwitch, TranslocoDirective],
  templateUrl: './department-settings-admin.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentSettingsAdminComponent implements OnInit {
  private readonly departmentAdminService = inject(DepartmentAdminService);

  readonly form = new FormGroup({
    isOpen: new FormControl(false),
    medicalSpecialtyId: new FormControl<number | null>(null),
  });

  ngOnInit(): void {
    this.departmentAdminService.department$.pipe(first()).subscribe({
      next: ({ isOpen, medicalSpecialtyId }) => this.form.patchValue({ isOpen, medicalSpecialtyId }),
    });

    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe({
      next: ({ isOpen, medicalSpecialtyId }) =>
        this.departmentAdminService.updateDepartment({
          isOpen,
          medicalSpecialtyId,
        }),
    });
  }
}
